import callAPiBase from './base';

const companiesApi = {
  getAuthEmail: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyAuthEmail',
      method: 'GET',
      useToken: true,
      title: 'Company - Get Firebase Email',
      params,
    }),
  getAuthCompanyEmail: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyResetPassword',
      method: 'POST',
      useToken: true,
      title: 'Company - Get Firebase Email',
      data,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyList',
      method: 'GET',
      useToken: true,
      title: 'Company - Get List',
      params,
    }),
  companyAuth: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyAuth',
      method: 'POST',
      useToken: false,
      title: 'Company - Login',
      data,
    }),
  report: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/reports',
      method: 'GET',
      useToken: true,
      title: 'Company - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyCreate',
      method: 'POST',
      useToken: true,
      title: 'Company - Create',
      data,
    }),
  vehicleCreate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/vehicleCreate',
      method: 'POST',
      useToken: true,
      title: 'Vehicle - Create',
      data,
    }),
  updateReportLimit: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyUpdateReportLimit',
      method: 'POST',
      useToken: true,
      title: 'Company - Update Report Limit',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Company - Update',
      data,
    }),
  vehicleUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/vehicleUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Vehicle - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Company - Delete',
      params,
    }),
  vehicleDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/vehicleDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Vehicle - Delete',
      params,
    }),
  paymentMethodList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/paymentConfigList',
      method: 'GET',
      useToken: true,
      title: 'Payment Method - Get List',
      params,
    }),
  paymentMethodCreate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/paymentConfigCreate',
      method: 'POST',
      useToken: true,
      title: 'Payment Method - Create',
      data,
    }),
  paymentMethodUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/paymentConfigUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Payment Method - Update',
      data,
    }),
  paymentMethodStatusUpdate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/paymentConfigUpdateStatus',
      method: 'PATCH',
      useToken: true,
      title: 'Payment Method Status - Update',
      data,
    }),
  paymentMethodDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/paymentConfigDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Company - Delete',
      params,
    }),
  companyBoletoConfigCreateMany: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyBoletoConfigCreateMany',
      method: 'POST',
      useToken: true,
      title: 'companies - companyBoletoConfigCreateMany',
      data,
    }),
  companyBoletoConfigList: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyBoletoConfigList',
      method: 'GET',
      useToken: true,
      title: 'companies - companyBoletoConfigList',
      params,
    }),
  companyBoletoConfigUpdateMany: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyBoletoConfigUpdateMany',
      method: 'PUT',
      useToken: true,
      title: 'companies - companyBoletoConfigUpdateMany',
      data,
    }),
  companyBoletoConfigDelete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyBoletoConfigDelete',
      method: 'DELETE',
      useToken: true,
      title: 'companies - DelcompanyBoletoConfigDeleteete',
      params,
    }),
};

export { companiesApi };
export default companiesApi;
